<template>
  <v-dialog v-model="dialog" width="1300" transition="fab-transition">
    <v-card class="pl-0 pr-0">
      <v-card-title>
        <div style="display: flex; justify-content: space-between; width: 100%">
          <div>
            <v-icon class="mr-3">fas fa-info-circle</v-icon>
            <!-- <i class="fas fa-info-circle"></i> -->
            <span class="description-selected">
              Detalle Venta
            </span>
          </div>

          <div style="display: flex;">
            <v-btn
              style="margin-right: 10px"
              dark
              color="success"
              width="140"
              class="float-right"
              @click="handleDownloadReport"
            >
              Descargar XLS
            </v-btn>
            <v-btn
              v-if="viewButtonPrint()"
              dark
              color="blue"
              width="140"
              class="float-right mr-2"
              @click="handlePrintVoucher"
            >
              Imprimir
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <div class="container-superior">
          <div class="container-left">
            <span class="name-left">Fecha</span>
            <span class="label-purchase value-left">{{
              sale.registration_date | moment("DD/MM/YYYY")
            }}</span>
          </div>
          <div class="container-right">
            <span class="label-discount name-right">Descuento</span>
            <span class="label-purchase label-discount value-right">{{
              sale.discount | currency("S/ ")
            }}</span>
          </div>
        </div>

        <div class="container-superior">
          <div class="container-left">
            <span class="name-left">Cliente</span>
            <span v-if="sale.customer" class="label-purchase value-left">
              {{ sale.customer.fullname }}
            </span>
            <span v-else class="label-purchase value-left">
              Público general
            </span>
          </div>
          <div class="container-right">
            <span class="label-discount name-right">Subtotal</span>
            <span class="label-purchase value-right">{{
              sale.subtotal | currency("S/ ")
            }}</span>
          </div>
        </div>

        <div class="container-superior">
          <div class="container-left">
            <span class="name-left">{{ sale.type_document }}</span>
            <span class="label-purchase value-left">
              {{ sale.serie }}-{{ sale.correlative }}
            </span>
          </div>
          <div class="container-right">
            <span class="label-discount name-right">IGV</span>
            <span class="label-purchase value-right">{{
              sale.igv | currency("S/ ")
            }}</span>
          </div>
        </div>

        <div class="container-superior">
          <div class="container-left">
            <span class="name-left"></span>
            <span class="label-purchase value-left"> </span>
          </div>
          <div class="container-right">
            <span class="label-discount name-right">Total</span>
            <span class="label-purchase value-right">{{
              sale.total | currency("S/ ")
            }}</span>
          </div>
        </div>
      </v-card-text>

      <v-card-text class="pb-0">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="detail"
            :items-per-page="10"
            class="elevation-1 w-table"
            height="57vh"
            fixed-header
          >
            <template v-slot:item.quantity="{ item }">
              <v-icon
                v-if="item.imei"
                class="mr-3"
                color="blue"
                size="18"
                @click="handleViewImeis(item)"
              >
                fas fa-search-plus
              </v-icon>
              <span>{{ item.quantity }}</span>
            </template>

            <template v-slot:item.price="{ item }">
              <span>{{ item.price | currency("S/") }}</span>
            </template>
            <template v-slot:item.discount_value="{ item }">
              <span>{{ item.discount_value | currency("S/") }}</span>
            </template>
            <template v-slot:item.subtotal="{ item }">
              <v-icon v-if="item.is_bonus" size="18" class="mr-2" color="green">
                fas fa-gift
              </v-icon>
              <span>{{ getAmountProductDiscount(item) | currency("S/") }}</span>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>

      <v-card-actions>
        <v-container class="pb-0"> </v-container>
      </v-card-actions>
      <v-card-actions>
        <v-container class="pt-0 pb-0"> </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TicketTools from "../../helpers/TicketTools";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "SalesDetail",
  data() {
    return {
      dialog: false,
      itemsBreadcrumbs: [
        {
          text: "Reportes",
          disabled: true,
          href: "",
        },
        {
          text: "Ventas",
          disabled: false,
          href: "/app/reportes/reporte-ventas",
        },
      ],
      headers: [
        { text: "CATEGORIA", value: "category_name", sortable: false },
        { text: "DESCRIPCION", value: "description", sortable: false },
        { text: "CANTIDAD", value: "quantity", sortable: false, align: "end" },
        { text: "PRECIO UND.", value: "price", sortable: false, align: "end" },
        {
          text: "DESCUENTO",
          value: "discount_value",
          sortable: false,
          align: "end",
        },
        { text: "TOTAL", value: "subtotal", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    ...mapState("report-sales", ["sale", "detail", "file_sales", "voucher"]),
  },
  methods: {
    showDialog() {
      this.getSaleDetail(this.sale);
      this.dialog = !this.dialog;
    },
    ...mapActions("report-sales", [
      "getSaleDetail",
      "saleDetailExcel",
      "getSaleVoucher",
    ]),
    handleViewImeis(detail) {
      this.$refs.imeisDialog.show(detail.imei);
    },
    async handleDownloadReport() {
      await this.saleDetailExcel(this.sale);
      if (this.file_sales) {
        let url = process.env.VUE_APP_API_URL_BASE + "/" + this.file_sales;
        window.open(url);
      }
    },
    async handlePrintVoucher() {
      await this.getSaleVoucher(this.sale.id);
      if (this.voucher) {
        let content = await TicketTools.printTicketVenta(this.voucher);
        this.printVoucher(content);
      }
    },
    printVoucher(content) {
      $("<iframe>", { name: "voucheriframe", class: "printFrame" })
        .appendTo("body")
        .contents()
        .find("body")
        .append(content);

      window.frames["voucheriframe"].focus();

      setTimeout(() => {
        window.frames["voucheriframe"].print();
      }, 400);

      setTimeout(() => {
        $(".printFrame").remove();
      }, 1000);
    },
    viewButtonPrint() {
      let view = false;
      if (
        this.sale.type_document == "TICKET" ||
        this.sale.type_document == "BOLETA" ||
        this.sale.type_document == "FACTURA"
      ) {
        view = true;
      }

      return view;
    },
    getAmountProductDiscount(item) {
      let amount = item.price * item.quantity - item.discount_value;
      amount = Math.round(amount * 100) / 100;

      return amount;
    },
  },
};
</script>

<style scoped>
.name-left {
  font-size: 15px;
  width: 40%;
}

.value-left {
  font-size: 15px;
  width: 50%;
  font-weight: 700;
  color: black;
}

.name-right {
  font-size: 15px;
  width: 50%;
}

.value-right {
  font-size: 15px;
  width: 50%;
  font-weight: 700;
  color: black;
  /* background-color: red; */
}

.container-left {
  display: flex;
  width: 20%;
}

.container-right {
  display: flex;
  width: 15%;
}

.container-superior {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 4px 0;
}
</style>
